import { getOrg } from "utils/site";
import { getInputFromState as getInputFromStateFra } from "./fra";
import { getInputFromState as getInputFromStateGer } from "./ger";
import { getInputFromState as getInputFromStateSwe } from "./swe";
import {
  Animal,
  Customer,
  Metadata,
} from "components/Signup/store/state/types";

export const getInputFromState = (input: {
  draftId: string | null;
  customer: Customer;
  metadata: Metadata;
  animals: Animal[];
}) => {
  const org = getOrg();

  switch (org) {
    case "fra":
      return getInputFromStateFra(input);
    case "ger":
      return getInputFromStateGer(input);
    case "swe":
      return getInputFromStateSwe(input);
    default:
      throw new Error(`Could not build input from state for org: ${org}`);
  }
};
